import _construct from "@babel/runtime/helpers/construct";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import 'reflect-metadata';
import { Injectable, Module, Scope } from '@tokamakjs/injection';
import { NoControllerMetadataError, NoSubAppMetadataError } from '../errors';
export var Reflector = /*#__PURE__*/function () {
  function Reflector() {
    _classCallCheck(this, Reflector);
  }

  _createClass(Reflector, null, [{
    key: "addControllerMetadata",
    value: function addControllerMetadata(target, metadata) {
      Injectable({
        scope: Scope.TRANSIENT
      })(target);
      Reflect.defineMetadata('self:controller', metadata, target);
    }
  }, {
    key: "getControllerMetadata",
    value: function getControllerMetadata(target) {
      var metadata = Reflect.getMetadata('self:controller', target);

      if (metadata == null) {
        throw new NoControllerMetadataError(target.name);
      }

      return metadata;
    }
  }, {
    key: "addSubAppMetadata",
    value: function addSubAppMetadata(target, metadata) {
      var routing = metadata.routing,
          moduleMetadata = _objectWithoutProperties(metadata, ["routing"]);

      Module(moduleMetadata)(target);
      Reflect.defineMetadata('self:subapp', _objectSpread(_objectSpread({}, moduleMetadata), {}, {
        routing: routing.flat()
      }), target);
    }
  }, {
    key: "getSubAppMetadata",
    value: function getSubAppMetadata(target) {
      var metadata = Reflect.getMetadata('self:subapp', target);

      if (metadata == null) {
        throw new NoSubAppMetadataError(target.name);
      }

      return metadata;
    }
  }, {
    key: "getEffectKeysMap",
    value: function getEffectKeysMap(target) {
      return Reflect.getMetadata('self:hookscontainer:effectkeysmap', target);
    }
  }, {
    key: "setInEffectKeysMap",
    value: function setInEffectKeysMap(target, key, deps) {
      var effectKeysMap = Reflector.getEffectKeysMap(target);

      if (effectKeysMap == null) {
        effectKeysMap = new Map();
        Reflect.defineMetadata('self:hookscontainer:effectkeysmap', effectKeysMap, target);
      }

      effectKeysMap.set(key, deps !== null && deps !== void 0 ? deps : function () {
        return undefined;
      });
    }
  }, {
    key: "getMemoKeysMap",
    value: function getMemoKeysMap(target) {
      return Reflect.getMetadata('self:hookscontainer:memokeysmap', target);
    }
  }, {
    key: "setInMemoKeysMap",
    value: function setInMemoKeysMap(target, key, deps) {
      var memoKeysMap = Reflector.getMemoKeysMap(target);

      if (memoKeysMap == null) {
        memoKeysMap = new Map();
        Reflect.defineMetadata('self:hookscontainer:memokeysmap', memoKeysMap, target);
      }

      memoKeysMap.set(key, deps !== null && deps !== void 0 ? deps : function () {
        return undefined;
      });
    }
  }, {
    key: "getStateKeys",
    value: function getStateKeys(target) {
      return Reflect.getMetadata('self:hookscontainer:statekeys', target);
    }
  }, {
    key: "addToStateKeys",
    value: function addToStateKeys(target, key) {
      var stateKeys = Reflector.getStateKeys(target);

      if (stateKeys == null) {
        stateKeys = [];
        Reflect.defineMetadata('self:hookscontainer:statekeys', stateKeys, target);
      }

      stateKeys.push(key);
    }
  }, {
    key: "getRefKeys",
    value: function getRefKeys(target) {
      return Reflect.getMetadata('self:hookscontainer:refkeys', target);
    }
  }, {
    key: "addToRefKeys",
    value: function addToRefKeys(target, key) {
      var refKeys = Reflector.getRefKeys(target);

      if (refKeys == null) {
        refKeys = [];
        Reflect.defineMetadata('self:hookscontainer:refkeys', refKeys, target);
      }

      refKeys.push(key);
    }
  }, {
    key: "copyMetadata",
    value: function copyMetadata(Source, Target) {
      var keys = Reflect.getMetadataKeys(Source);
      keys.forEach(function (key) {
        return Reflect.defineMetadata(key, Reflect.getMetadata(key, Source), Target);
      });
    }
  }, {
    key: "addHookServiceMetadata",
    value: function addHookServiceMetadata(Target) {
      Reflect.defineMetadata('self:hookservice', {}, Target);
    }
  }, {
    key: "getHookServiceMetadata",
    value: function getHookServiceMetadata(Target) {
      return Reflect.getMetadata('self:hookservice', Target);
    }
  }, {
    key: "createHooksContainer",
    value: function createHooksContainer(Target) {
      var _Reflector$getStateKe, _Reflector$getRefKeys, _Reflector$getEffectK, _Reflector$getMemoKey;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var inst = _construct(Target, args);

      var stateKeys = (_Reflector$getStateKe = Reflector.getStateKeys(inst)) !== null && _Reflector$getStateKe !== void 0 ? _Reflector$getStateKe : [];
      var refKeys = (_Reflector$getRefKeys = Reflector.getRefKeys(inst)) !== null && _Reflector$getRefKeys !== void 0 ? _Reflector$getRefKeys : [];
      var effectKeysMap = (_Reflector$getEffectK = Reflector.getEffectKeysMap(inst)) !== null && _Reflector$getEffectK !== void 0 ? _Reflector$getEffectK : new Map();
      var memoKeysMap = (_Reflector$getMemoKey = Reflector.getMemoKeysMap(inst)) !== null && _Reflector$getMemoKey !== void 0 ? _Reflector$getMemoKey : new Map();
      inst.__reactHooks__ = {
        stateKeys: stateKeys,
        refKeys: refKeys,
        effectKeysMap: effectKeysMap,
        memoKeysMap: memoKeysMap
      };
      return inst;
    }
  }, {
    key: "createDecoratedController",
    value: function createDecoratedController(Target) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var inst = Reflector.createHooksContainer.apply(Reflector, [Target].concat(args));
      var metadata = Reflector.getControllerMetadata(Target);
      inst.__controller__ = metadata;
      return inst;
    }
  }]);

  return Reflector;
}();